"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiPaper = function MuiPaper(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the `Paper` component. */
    outlined: {
      borderColor: borderColor
    }
  };
};

var _default = MuiPaper;
exports["default"] = _default;